export default function How() {
    return (
        <section className="py-6 sm:py-8 md:py-10 comment-pricing">
            <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                <div className="text-center mb-8 sm:mb-12">
                    <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black text-white mb-3">
                        <span className="text-white">
                            ¿Cómo funciona?
                        </span>
                    </h2>
                    <div className="w-40 h-1 bg-orange-500 mx-auto rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 lg:gap-12 mb-8 sm:mb-12">
                    <div className="flex flex-col items-center text-center group">
                        <div className="relative mb-4 sm:mb-6">
                            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                <span className="text-white font-black text-xl sm:text-2xl">1</span>
                            </div>
                            <div className="absolute -bottom-2 -right-2 w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full flex items-center justify-center shadow-md">
                                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                                </svg>
                            </div>
                        </div>
                        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">
                            Realice su pedido
                        </h3>
                        <p className="text-sm sm:text-base text-orange-100 leading-relaxed max-w-xs">
                            Realice su pedido eligiendo su suscripción preferida.
                        </p>
                    </div>

                    <div className="flex flex-col items-center text-center group">
                        <div className="relative mb-4 sm:mb-6">
                            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                <span className="text-white font-black text-xl sm:text-2xl">2</span>
                            </div>
                            <div className="absolute -bottom-2 -right-2 w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full flex items-center justify-center shadow-md">
                                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                            </div>
                        </div>
                        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">
                            Obtenga su cuenta
                        </h3>
                        <p className="text-sm sm:text-base text-orange-100 leading-relaxed max-w-xs">
                            Después de realizar el pago, nos pondremos en contacto con usted por correo electrónico en menos de 10 minutos con sus credenciales de inicio de sesión y una guía de instalación.
                        </p>
                    </div>

                    <div className="flex flex-col items-center text-center group">
                        <div className="relative mb-4 sm:mb-6">
                            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                <span className="text-white font-black text-xl sm:text-2xl">3</span>
                            </div>
                            <div className="absolute -bottom-2 -right-2 w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full flex items-center justify-center shadow-md">
                                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">
                            Disfrute de su IPTV
                        </h3>
                        <p className="text-sm sm:text-base text-orange-100 leading-relaxed max-w-xs">
                            ¡Disfrute ahora de todos los canales, películas y series!
                        </p>
                    </div>
                </div>

                <div className="bg-black/95 backdrop-blur-sm rounded-2xl p-6 sm:p-8 md:p-10 text-center flex flex-col items-center border border-gray-900/80">
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-4 sm:mb-6">
                        Elija el Proveedor <span className="text-white">IPTV</span> Número 1 en España
                    </h3>
                    <a href="#pricing" className="w-full sm:w-96 bg-orange-500 hover:from-orange-400 hover:via-orange-600 hover:to-orange-400 hover:brightness-125 text-white font-black py-3 sm:py-4 px-6 sm:px-8 rounded-xl text-sm sm:text-base transition-all duration-700 transform shadow-2xl hover:shadow-orange-500/30 hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2 sm:gap-3">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                        </svg>
                        Comprar ahora
                    </a>
                </div>
            </div>
        </section>
    );
}
